import React from 'react'
import LabelCard from './components/label-card'
import Tag from '../../../components/svg/tag'
import Grid from '../../../components/svg/grid'
import Search from '../../../components/svg/search'
import CreditCard from '../../../components/svg/credit-card'
import PieChart from '../../../components/svg/pie-chart'
import Umbrella from '../../../components/svg/umbrella'
import { ROUTES } from '../../../constants'

// ----------------------------------------------------------------------

const LabelsConfig = [
  {
    id: '1',
    title: 'Buying a vehicle',
    description: 'How our buying process works',
    icon: <Tag />,
    href: `${ROUTES.Buy}`,
    enabled: true,
  },
  {
    id: '2',
    title: 'Selling your vehicle',
    description: 'How our selling process works',
    icon: <Grid />,
    href: ROUTES.Sell,
    enabled: true,
  },
  {
    id: '3',
    title: 'Find a vehicle',
    description: 'Search our marketplace for your ideal vehicle',
    icon: <Search />,
    href: ROUTES.Search,
    enabled: true,
  },
  {
    id: '4',
    title: 'Finance your purchase',
    description: 'Coming soon',
    icon: <CreditCard />,
    href: '',
    enabled: false,
  },
  {
    id: '5',
    title: 'Refinance your vehicle',
    description: 'Coming soon',
    icon: <PieChart />,
    href: '',
    enabled: false,
  },
  {
    id: '6',
    title: 'Protect your vehicle',
    description: 'Coming soon',
    icon: <Umbrella />,
    href: '',
    enabled: false,
  },
]
// ----------------------------------------------------------------------

const LabelsSection = () => {
  return (
    <div className='root'>
      <div className='labelCards'>
        {LabelsConfig.map((cardProps) => (
          <LabelCard key={cardProps.id} {...cardProps} />
        ))}
      </div>
      <style jsx>{`
        .root {
          position: relative;
          height: 300px;
          padding: 0;
        }

        .labelCards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 3.8rem;
          padding: 0;
          max-width: 192rem;
          margin: 0 auto;
          background-color: transparent;

          position: absolute;
          top: 0%;
          left: 50%;
          transform: translate(-50%, -22%);
          width: 90%;
        }

        @media (max-width: 1200px) {
          .labelCards {
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 3rem;
          }
        }
        @media (max-width: 1024px) {
          .root {
            height: 700px;
          }
          .labelCards {
            padding: 3rem;
            grid-template-columns: 1fr;
            grid-gap: 2rem;
            transform: translate(-50%, -10%);
          }
        }
      `}</style>
    </div>
  )
}

export default LabelsSection
